// extracted by mini-css-extract-plugin
export default {"baseText":"ParticipantIdentification_baseText__nEba4","nameText":"ParticipantIdentification_nameText__CNxAW","noDataBox":"ParticipantIdentification_noDataBox__UsXM5"};